import React, { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import { ProviderServices } from '../CrudServices';
import { useParams } from 'react-router-dom';
import { BookingService } from '../../Booking/Service';
import { RoleGuard } from '../../../components/RoleGuard';

const ServiceTable = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {id} = useParams();
    const {} = props;
    const [categoryList,setCategoryList] = useState([]);
    const [subCategoryList,setSubCategoryList] = useState([]);
    const [serviceList,setServiceList] = useState([]);
    const [providerServiceModal,setProviderServiceModal] = useState({});
    /* =====================datagrid table related =========================*/
    const [loading, setLoading] = useState(false);
    const [allRowCount, setAllRowCount] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        pageSize: 50,
        filters: {
          searchKey: "",
          status: 1,
        }
    });

    /*===========fetch servicelist of provider =========== */
    const fetchProviderServiceList = async(fetchParameters)=>{
      setLoading(true);
    
      const providerServiceListResponse = await ProviderServices.fetchProviderServices(fetchParameters);
      // console.log("provider service list Response:",providerServiceListResponse)
      // setProviderServiceList(providerServiceListResponse?.data?.list);
      const fetchedServiceList = providerServiceListResponse?.data?.list;
      const newServiceList = fetchedServiceList.map(item => {
        return {
          id: item.id,
          servicesMasterId: item.servicesMasterId,
          servicesChildId: item.servicesChildId,
          subCategoryId: item.childService?.ServiceCategoryRels[0]?.serviceCategoryId,
          subCategoryTitle: item.childService?.ServiceCategoryRels[0]?.ServiceCategory?.title,
          categoryId: item.childService?.ServiceCategoryRels[0]?.ServiceCategory?.cat.id,
          categoryTile: item.childService?.ServiceCategoryRels[0]?.ServiceCategory?.cat.title,
          masterServiceTitle: item?.childService?.parentService?.title,
          childServiceTitle: item.childService?.title,
          serviceTime: item.serviceTime,
          price: item.price,
          visitingCharge: item?.providerServiceCharge?.vistingCharge,
          brand: item?.brd
        };
      });
      setServiceList(newServiceList);
      // setProviderServiceModal({
      //   currentPage: providerServiceListResponse.data?.currentPage,
      //   totalItems:providerServiceListResponse.data?.totalItems,
      //   totalPages:providerServiceListResponse.data?.totalPages
      // })
      setAllRowCount(providerServiceListResponse.data?.totalItems)
      setLoading(false);
    }

    /*=============on compopnent load ============ */
    useEffect(()=>{
      const fetchCategoryList= async()=>{
          try {
            const categoryListResponse = await BookingService.categoryList();
            // console.log("category list Response:",categoryListResponse);
            if(categoryListResponse.success===1){
              setCategoryList(categoryListResponse.data)
            }
          } catch (error) {
            
          }
        }
        fetchCategoryList();
        if (id>0) {
          let fetchParameters = {
            providerId:id,
            page:1,
            pageSize:5,
          }
          fetchProviderServiceList(fetchParameters);
      }
    },[]);
    const handlePaginationChange = (newPagination) => {
        setController({
          ...controller,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    }

    const columns = [
        {
            field: 'id',
            headerName: 'S.No',
            width: 100,
            headerAlign: 'center',
            flex:0.5,
            valueGetter: (params) => 
              controller.page * controller.pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id)+1,
        },
        {
            field:'subCategoryTitle', headerAlign: 'center', headerName: "Category Details", flex: 2,editable: false,
            renderCell:(params)=>{
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.subCategoryTitle}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>
                        ({params.row.subCategoryId})
                      </Box>
                    </RoleGuard>
                  </Typography>
                  <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>({` ${params.row.categoryTile} `}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{  fontWeight: 600, color: '#382cd5' }}>
                        _{params.row.categoryId}
                      </Box>
                    </RoleGuard>
                  )
                  </Typography>
                </Box>
              )
            }
        },
        {
            field:'masterServiceTitle', headerAlign: 'center', headerName: "Service Details", flex: 2,editable: false,
            renderCell:(params)=>{
              return(
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.childServiceTitle}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>
                        ({params.row.servicesChildId})
                      </Box>
                    </RoleGuard>
                  </Typography>
                  <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>({` ${params.row.masterServiceTitle} `}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{  fontWeight: 600, color: '#382cd5' }}>
                        _{params.row.servicesMasterId}
                      </Box>
                    </RoleGuard>
                  )
                  </Typography>
                </Box>
              )
            }
        },
        {
            field:'brand', headerAlign: 'center', headerName: "Brand", flex: 1,editable: false,
            renderCell:(params)=>{
              return(
                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                  <Typography sx={{fontSize:'.75rem'}}>{params.row?.brand?.title}</Typography>
                </Box>
              )
            }
        },
        {
            field:'serviceTime', headerAlign: 'center', headerName: "Service Time", flex: 1,editable: false,
            renderCell:(params)=>{  
              return(
                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                  <Typography sx={{fontSize:'.75rem'}}>{params.row.serviceTime} mins.</Typography>
                </Box>
              )
            }
            
        },
        {
            field:'price', headerAlign: 'center', headerName: "Price", flex: 1,editable: false,
            renderCell:(params)=>{  
              return(
                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                  <Typography sx={{fontSize:'.75rem'}}>₹ {params.row.price}</Typography>
                </Box>
              )
            }
        },
        {
          field:'visitingCharge', headerAlign: 'center', headerName: "Visiting Charge", flex: 1,editable: false,
          renderCell:(params)=>{  
            return(
              <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Typography sx={{fontSize:'.75rem'}}>₹ {params.row.visitingCharge}</Typography>
              </Box>
            )
          }
        },
    ]

  useEffect(()=>{
    fetchProviderServiceList({
        providerId:id,
        page:controller.page+1,
        pageSize:controller.pageSize,
    });
  },[controller]);
  // useEffect(()=>{
  //   setAllRowCount(providerServiceModal?.totalItems);
  // },[])
  return (
    <>
      {/* <Box sx={{p:'.5% 2%',border:'2px solid lightGray',bgcolor:'lightGray',width:'100%'}}>
        <Typography sx={{fontWeight:'600',fontSize:'.85rem'}}>Service List</Typography>
      </Box> */}
        <Box sx={{ overflow: "auto" }}>
            <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff",borderRadius:'.5rem' }}>
                <DataGrid
                    rows={serviceList}
                    columns={columns.map((col) => ({
                      ...col,
                      // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
                      minWidth: isSmallScreen && (col.minWidth || 100), // Set a minimum width to avoid overlap
                    }))}
                    // getRowId={(row) => row.servicesChildId}
                    //checkboxSelection={true}
                    rowCount={allRowCount}  // Use the length of the filtered list
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    paginationModel={controller}
                    paginationMode="server"
                    onPaginationModelChange={handlePaginationChange}

                    loading={loading}

                    disableColumnMenu
                    disableRowSelectionOnClick
                    slots={{
                        // toolbar: GridToolbar,
                        noRowsOverlay: NoRowsLayout,
                    }}

                    getRowHeight={() => 'auto'}
                    // autoHeight
                    sx={{
                      height:'68vh',
                    '--DataGrid-overlayHeight': '300px',
                    "& .MuiDataGrid-cell": {
                        border: 1,
                        borderRight: 0,
                        borderTop: 0,
                        borderColor: 'lightgrey',
                        p: 1,
                        textAlign: 'center',
                        justifyContent: 'center',
                        fontSize:'.75rem'
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                        borderTop: '2px solid rgba(224, 224, 224, 1)',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        borderLeft: '1px solid rgba(224, 224, 224, 1)',
                        '&:last-child': {
                        borderRight: 'none',
                        },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: '600',
                        color: '#3e3e3e',
                        fontSize:'.75rem'
                    },
                    '& .MuiDataGrid-row': {
                        '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        },
                        '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                        },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                        display: 'none',
                    },
                    }}
                />
            </Box>
        </Box>
    </>
  );
}

export default ServiceTable;
